import { useLazyQuery } from "@apollo/client";

import { UserPrefillDataQuery, UserPrefillDataQueryVariables } from "@ctypes";
import { USER_PREFILL_DATA } from "@graphql";

export const useFetchVerifiedPrefill = () => {
  return useLazyQuery<UserPrefillDataQuery, UserPrefillDataQueryVariables>(USER_PREFILL_DATA, {
    fetchPolicy: "cache-and-network",
  });
};
